import React from 'react'
import styled from 'styled-components'

const HomePageDiv = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  vertical-align: center;
`

function Home() {
  return <HomePageDiv></HomePageDiv>
}

export default Home
